import React from "react";
import { Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { UiContext } from "../contexts/ui";
import { BackgroundNavProvider } from "../contexts/backgroundNav";
import { selectWidgets } from "../db/select";
import { db } from "../db/state";
import { useSelector, useValue } from "../lib/db/react";
import { getConfig } from "../plugins";
import Plugin from "../components/Plugin";
import Background from "../components/Background";
import BackgroundNav from "../components/BackgroundNav";
import Widget from "../components/Widget";
import "./Dashboard.sass";

const DashboardLayout: React.FC = () => {
  const { toggleSettings } = React.useContext(UiContext);
  const focus = useValue(db, "focus");
  const widgets = useSelector(db, selectWidgets);

  const sorted = [...widgets].sort((a, b) => a.order - b.order);

  return (
    <BackgroundNavProvider>
      <div className="dashboard">
        <div className="dashboard__bg">
          <Background />
        </div>

        <div className="dashboard__gradient" />

        {!focus && (
          <div className="dashboard__content">
            {sorted.map((widget) => {
              const config = getConfig(widget.key);
              return (
                <Widget
                  key={widget.id}
                  {...widget.display}
                  className={`dashboard__widget ${widget.key === "widget/luminaverse" ? "dashboard__widget--keep-centered dashboard__widget--anchor-bottom" : ""} ${widget.key === "widget/weather" ? "dashboard__widget--anchor-top-right" : ""} ${widget.display.className ?? ""}`.trim()}
                >
                  <Plugin
                    id={widget.id}
                    component={config.dashboardComponent}
                  />
                </Widget>
              );
            })}
          </div>
        )}

        <div className="dashboard__settings">
          <Button
            size="small"
            icon={<MenuOutlined />}
            onClick={toggleSettings}
            ghost
          />
        </div>
      </div>
      <BackgroundNav />
    </BackgroundNavProvider>
  );
};

export default DashboardLayout;
